import { useCallback, useContext } from 'react';
import { EffectContext } from '../../../common/view/effect/effect.context';
import { MonoIcon } from '../../../common/view/icon/mono/mono-icon';
import { Menu } from '../../../common/view/menu/menu';
import { MenuItem } from '../../../common/view/menu/menu-item';
import { MenuStyle } from '../../../common/view/menu/menu.style';
import { ImmerFuncs } from '../../../external/immer/immer.funcs';
import { ServerApi } from '../../../external/server/server.api';
import { ArrayFuncs } from '../../../foundation/js/array.funcs';
import { Optional } from '../../../foundation/js/optional';
import { BasicNodeSubWireFuncs } from '../../core/node/basic-node-sub.wire.funcs';
import { NodeStore } from '../../core/node/node.store';
import { NodeWireFuncs } from '../../core/node/node.wire.funcs';
import { EffectMenuItems } from '../effect/effect-menu-items';

export function NodeItemMenu({ nodeId, onRemove }: { nodeId: string; onRemove: Optional<(nodeId: string) => void> }) {
  const node = NodeStore.useItem(nodeId);
  const { popupApi } = useContext(EffectContext);
  /*
   * MARK - Add
   */

  const handleAdd = useCallback(async () => {
    popupApi.pop();

    if (!nodeId) {
      return;
    }

    const newNode = NodeWireFuncs.init({
      text: 'New Sub Task',
    });
    NodeStore.updateItem(newNode.id, newNode);

    const sub = ImmerFuncs.produce(ArrayFuncs.ensure(node?.sub), (draft) => {
      BasicNodeSubWireFuncs.addItem(draft, { child: newNode.id });
    });
    NodeStore.updateItem(nodeId, { sub });

    const createdNode = await ServerApi.createNode(newNode);
    NodeStore.updateItem(createdNode.id, createdNode);

    await ServerApi.updateNode(nodeId, { sub });
  }, [nodeId, node]);

  /*
   * MARK - Remove
   */

  const handleRemove = useCallback(() => {
    popupApi.pop();

    if (!nodeId) {
      return;
    }

    onRemove?.(nodeId);
  }, [nodeId, onRemove]);

  return (
    <Menu width={'400px'}>
      <MenuItem icon={MonoIcon.plus} text={'Add Sub Item'} onClick={handleAdd} />
      <MenuStyle.Separator />
      <EffectMenuItems nodeId={nodeId} />
      <MenuStyle.Separator />
      <MenuItem icon={MonoIcon.trash} text={'Remove'} danger onClick={handleRemove} />
    </Menu>
  );
}
